export const dataKeys = {
  // General
  labels: "labels",
  articleSearchOperator: "articleSearchOperator",
  subject: "subject",
  message: "message",
  files: "files",
  showValidation: "showValidation",
  resolutionLinks: "resolutionLinks",
  // Homey
  diagnosticReport: "diagnosticReport",
  homeyApps: "homeyApps",
  homeyBridges: "homeyBridges",
  homeyId: "homeyId",
  homeyLanguage: "homeyLanguage",
  homeyLicenses: "homeyLicenses",
  homeyModel: "homeyModel",
  homeyModelName: "homeyModelName",
  homeyPlatform: "homeyPlatform",
  homeyRegion: "homeyRegion",
  homeySoftwareVersion: "homeySoftwareVersion",
  homeyUsers: "homeyUsers",
  underVoltageRatio: "underVoltageRatio",
  // App
  appId: "appId",
  appAuthor: "appAuthor",
  appBuild: "appBuild",
  supportType: "supportType",
  // Driver
  driverId: "driverId",
  // Orders
  orderId: "orderId",
  // Subscriptions
  subscriptionId: "subscriptionId",
  // AI generated subject
  path: "path",
}
